var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialTiktok = function SvgSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.85 7.25c-.9-.55-1.5-1.45-1.65-2.5-.05-.25-.05-.45-.05-.7H12.4v11a2.274 2.274 0 0 1-2.3 2.2c-.35 0-.75-.1-1.05-.25-.75-.4-1.25-1.2-1.25-2.05 0-1.25 1.05-2.3 2.3-2.3.25 0 .45.05.7.1v-2.8c-.25-.05-.45-.05-.7-.05-2.8 0-5.05 2.25-5.05 5.05 0 1.7.85 3.2 2.15 4.15-.3-.35 0 0 0 0 .85.6 1.85.9 2.9.9 2.8 0 5.05-2.25 5.05-5.05v-5.6c1.1.8 2.45 1.25 3.8 1.25V7.85q-1.125 0-2.1-.6"
  })));
};
export default SvgSocialTiktok;